export default __webpack_public_path__ + "static/media/raffleIcon.948b6ae0.png";